function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\r\n        .st0{fill:#FFFFFF;}\r\n        .st1{fill:#4e91ca;}\r\n    ");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "st1",
  d: "M0 0L640 0L640 40L0 40L0 0Z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "st1",
  d: "M0 600L640 600L640 640L0 640L0 600Z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  className: "st1",
  d: "M40 22.13L40 618.16L0 618.16L0 22.13L40 22.13Z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  className: "st1",
  d: "M640 21.97L640 618L600 618L600 21.97L640 21.97Z"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  className: "st1",
  d: "M620 549.53C620 587.87 590.16 619 553.4 619C516.65 619 486.81 587.87 486.81 549.53C486.81 511.19 516.65 480.06 553.4 480.06C590.16 480.06 620 511.19 620 549.53Z"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M591.63 545.42C591.63 567.64 574.45 585.67 553.3 585.67C532.14 585.67 514.96 567.64 514.96 545.42C514.96 523.21 532.14 505.17 553.3 505.17C574.45 505.17 591.63 523.21 591.63 545.42Z"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M571.78 570.9L579.82 564.26L619.33 612.07L611.3 618.71L571.78 570.9Z"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  className: "st1",
  d: "M580 545.6C580 560.27 568.08 572.19 553.4 572.19C538.73 572.19 526.81 560.27 526.81 545.6C526.81 530.92 538.73 519 553.4 519C568.08 519 580 530.92 580 545.6Z"
});

var SvgSelectedImageIcon = function SvgSelectedImageIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    viewBox: "0 0 640 640",
    width: 200,
    height: 200,
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSelectedImageIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/selectedImageIcon.1370023f.svg";
export { ForwardRef as ReactComponent };